import { ProjectCategory } from "@remi/enums/project-category";
import { ENSITE_ORG } from "@remi/types/organizations";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_NUMERIC_ID } from "../utils/types";

export type ContractorProfile = {
  organizationId: string;
  isRemiLicensedLabor: boolean;
};

type Project = {
  category: ProjectCategory;
};

export const workOrder = {
  read: (user: User) => hasCapability(user, "workOrder.read"),
  create: (user: User) => hasCapability(user, "workOrder.create"),
  update: (user: User, contractor: ContractorProfile, project?: Project) => {
    if (hasCapability(user, "workOrder.update")) {
      return true;
    }

    const canContractorUpdate =
      user.person.organizationId === contractor.organizationId && hasCapability(user, "workOrder.update.own");

    // Lowered permissions: REMI_USER can update SITE_VISIT projects, Remi-licensed labor
    // contractors, or any Ensite work order — Ensite's non-SITE_VISIT projects would otherwise
    // be REMI_ADMIN-only (ODD-7338).
    const isRemiUserCheckUsed =
      project?.category === ProjectCategory.SITE_VISIT ||
      contractor.isRemiLicensedLabor ||
      contractor.organizationId === ENSITE_ORG.id;
    const canRemiUserUpdate = isRemiUserCheckUsed && hasCapability(user, "workOrder.update.remi");

    return canContractorUpdate || canRemiUserUpdate;
  },
};

export const workOrderWhere = (user: User) => {
  return hasCapability(user, "workOrder.read.all") ? {} : { AND: [{ id: NON_EXISTENT_NUMERIC_ID }] };
};
